var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chart-bounds"}},[(!_vm.chartData.length)?_c('h3',{staticClass:"header-select-states"},[_vm._v("Select some States!")]):_vm._e(),_c('div',{attrs:{"id":"chart"}})])}
var staticRenderFns = []

export { render, staticRenderFns }